import { app } from '../resources/gcp-config';
import { getFirestore, doc, setDoc, serverTimestamp } from 'firebase/firestore';

const db = getFirestore(app);

export async function setQuoteDefaults({ marginDefault, gAndADefault }) {
  try {
    const ref = doc(db, 'appSettings', 'quoteDefaults');
    await setDoc(
      ref,
      {
        marginDefault: Number(marginDefault) || 0,
        gAndADefault: Number(gAndADefault) || 0,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
    return true;
  } catch (e) {
    console.error('Error setting quote defaults:', e);
    return false;
  }
}


